/**
 * TanStack Query hook for the Rejected Plans report (Reporting page).
 *
 * GET /api/reports/plan-rejections returns the whole scoped log in one call, so sorting and
 * searching happen client-side over that array (see PlanRejectionsTable.tsx).
 */

import { useQuery } from "@tanstack/react-query";
import { jsonFetch } from "@/lib/json-fetch";
import { planRejectionKeys } from "@/lib/query";
import type { PlanRejectionReportRow } from "@/schemas/resource-plans";

export type { PlanRejectionReportRow };

export function usePlanRejections() {
  return useQuery({
    queryKey: planRejectionKeys.list(),
    queryFn: () => jsonFetch<PlanRejectionReportRow[]>("/api/reports/plan-rejections"),
    staleTime: 60_000,
  });
}
